import { useMemo, useCallback } from "react";
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from '@mui/x-data-grid';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Navbar from "../../Components/Navbar";
import { Edit } from "@mui/icons-material";
import { useBranchRegionContext } from "../../Context/BranchRegionContext";
import { IBranchHierarchyRegionDto } from "../../@types/branchRegion";
import BranchRegionDialog from "./BranchRegionDialog";
import { StyledButton } from "../../Components/ui/CustomButton";


function BranchRegionPage(): JSX.Element {
    const branchRegionContext = useBranchRegionContext()
    const branchRegions = branchRegionContext?.branchRegions

    const handleEdit = useCallback((params: any) => {
        let curBranchRegionDto = params.row as IBranchHierarchyRegionDto   

        branchRegionContext?.setSelectedEmployeeId(curBranchRegionDto.managerEmployeeGuid);
        branchRegionContext?.setSelectedRegionId(curBranchRegionDto.branchRegionId.toString());
        branchRegionContext?.setSelectedTitle(curBranchRegionDto.title);
        branchRegionContext?.setBranchRegionDto({
            branchRegionId: curBranchRegionDto.branchRegionId,
            manager: curBranchRegionDto.manager,
            managerEmployeeId: curBranchRegionDto.managerEmployeeId,
            managerEmployeeGuid: curBranchRegionDto.managerEmployeeGuid,
            title: curBranchRegionDto.title,
            isActive: curBranchRegionDto.isActive
        });

        branchRegionContext?.setOpen(true);
    }, [branchRegionContext]);

    const columns: GridColDef[] = useMemo(() => [
        { field: 'branchRegionId', flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Region Id'}</strong>), renderCell: (params) =>
                (<strong style={{ fontWeight: 1000 }}>{params.value}</strong>) },
        { field: 'title',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Region'}</strong>) },
        { field: 'isActive',flex: 1,  headerClassName: 'header-color',renderHeader: () => (<strong>{'Is Active'}</strong>) },
        { field: 'manager',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Manager'}</strong>) },
        { field: 'managerEmployeeId',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Manager Employee Id'}</strong>), hide: true },
        { field: 'managerEmployeeGuid',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Manager Employee Guid'}</strong>), hide: true },
        {
            field: 'actions',
            headerClassName: 'header-color',
            editable: false,
            disableExport: true,
            renderHeader: () => (<strong>{'Actions'}</strong>),
            renderCell: (params: GridRenderCellParams) => (
                <Edit
                    onClick={() => {
                        handleEdit(params)
                    }}
                    sx={{ cursor: 'pointer' }}
                />
            )
        }
    ], [handleEdit]);

    const filteredRows = useMemo(
        () => branchRegions?.filter((row) => row.isActive),
        [branchRegions]
      );

    const handleClickOpen = () => {
        branchRegionContext?.setOpen(true);
    };

    const handleClose = () => {
        branchRegionContext?.setBranchRegionDto({
            branchRegionId: 0,
            manager: '',
            managerEmployeeId: 0,
            managerEmployeeGuid: '',
            title: '',
            isActive: false
        });
        branchRegionContext?.setSelectedEmployeeId((""))
        branchRegionContext?.setSelectedRegionId((""))
        branchRegionContext?.setSelectedTitle("")
        branchRegionContext?.setOpen(false);
    };

    return (
        <>
        <Navbar />
         <div className="paper-content">
   <div className="no-padding">
   <h1 className="grid-page-title">Region Table</h1> 
   </div>
   <div style={{ height: 700, width: '100%', boxShadow:'0 3px 10px rgb(0 0 0 / 0.2)' }}>
   <DataGrid
                        components={{ Toolbar: GridToolbar }}
                        sx={{
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: "rgb(245,245,245)"
                              },
                            width: '100%',
                            padding: '2%',
                            '& .header-color': {
                              color: '#004d84',
                              backgroundColor:'rgb(245,245,245)'
                            },
                          }}
                        componentsProps={{
                            toolbar: {
                                csvOptions: { disableToolbarButton: false },
                                printOptions: { disableToolbarButton: true },
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 250 },
                            },
                        }}
                        rows={filteredRows || []}
                        getRowId={(row: IBranchHierarchyRegionDto) => row.branchRegionId}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'branchRegionId', sort: 'asc' }],
                            }
                        }}
                    />
   </div>
   <br/>
   <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <StyledButton color="success" variant="contained" onClick={handleClickOpen}> Add New Region {<AddBoxOutlinedIcon />}</StyledButton> 
                    </div>
   </div>
       
            <BranchRegionDialog close={handleClose} />
          
        </>
    );
}

export default BranchRegionPage;